//
//
//
//
//

export default {
  name: "Confetti"
}
